import { createStructuredSelector } from 'reselect';

import {
  appealAgreementOnSelector,
  appealResultNotReadySelector,
  examDataLoaderSelector,
  invalidExamAttributesSelector,
  examListSelector,
  examsAvailabilitySelector,
} from '../../store/examData/selectors';

import {
  giaSelectedSelector,
  giaRegistrationCodesSelector,
  giaDocumentNumbersSelector,
  giaBlurSelector,
} from '../../store/gia/selectors';

const structuredSelector = createStructuredSelector({
  agreementOn: appealAgreementOnSelector,
  invalidExamAttributes: invalidExamAttributesSelector,
  appealResultNotReady: appealResultNotReadySelector,
  loadingExamData: examDataLoaderSelector,
  giaSelected: giaSelectedSelector,
  giaBlur: giaBlurSelector,
  registrationCodes: giaRegistrationCodesSelector,
  documentNumbers: giaDocumentNumbersSelector,
  subjectsInfo: examListSelector,
  hasAvailableExams: examsAvailabilitySelector,
});

export default structuredSelector;
